module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_7005.905535ae.png";